import {
  AxiosResponse,
} from 'axios';
import {
  acceptHMRUpdate,
  defineStore,
} from 'pinia';

import {
  TGetLicenseRouteResponse,
  getLicenseRoute,
  setLicenseRoute,
} from '@/generated/qmulus/axios/core.ts';
import {
  components,
} from '@/generated/qmulus/openapi.ts';

export const useLicenseStore = defineStore('license', {
  state: () => ({
    licenseResponse: undefined as TGetLicenseRouteResponse | undefined,
    licensePromise: undefined as Promise<AxiosResponse<TGetLicenseRouteResponse>> | undefined,
  }),
  getters: {
    isLoadingLicense(state): boolean {
      return state.licenseResponse === undefined || state.licensePromise !== undefined;
    },
    isLicenseError(state): boolean {
      return state.licenseResponse !== undefined && !state.licenseResponse.isValid;
    },
    licenseError(state): components['schemas']['QmulusLicenseViolationReason'] | undefined {
      if (this.isLicenseError) {
        return state.licenseResponse!.violation as components['schemas']['QmulusLicenseViolationReason'];
      }
      return undefined;
    },
    license(state): components['schemas']['QmulusLicense'] | undefined {
      if (this.isLoadingLicense) {
        return undefined;
      }
      return state.licenseResponse!.license!;
    },
  },
  actions: {
    async loadLicense(force?: boolean) {
      if (this.licensePromise) {
        return (await this.licensePromise!).data;
      }
      if (this.licenseResponse && !force) {
        return this.licenseResponse!;
      }

      this.licensePromise = getLicenseRoute();
      try {
        this.licenseResponse = (await this.licensePromise!).data;
      } finally {
        this.licensePromise = undefined;
      }
      return this.licenseResponse!;
    },
    async setLicense(licenseKey: string) {
      return setLicenseRoute({
        bodyParams: licenseKey,
      });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLicenseStore, import.meta.hot));
}
